import { GET_CLIENT_PAYMENT_TOKEN, CLEAR_CLIENT_PAYMENT_TOKEN } from '../actionTypes';

const initialState = {};

export default function (state = initialState, action=null) {
  switch (action.type) {
    case GET_CLIENT_PAYMENT_TOKEN:
      return {
        ...state,
        token: action.payload
      }
    case CLEAR_CLIENT_PAYMENT_TOKEN:
      return {
        ...state,
        token: ''
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/payments.js